import { provideStore, provideState, META_REDUCERS } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';

import { StorageService } from 'src/app/modules/core/services/storage.service';

import { ConstructionProgressEffects } from 'src/app/modules/ngrx-store/construction-progress/construction-progress.effects';
import { HomeResetEffects } from 'src/app/modules/ngrx-store/home-reset/home-reset.effects';
import { MessageEffects } from 'src/app/modules/ngrx-store/message/message.effects';
import { RealtorEffects } from 'src/app/modules/ngrx-store/realtor/realtor.effects';
import { ServiceRequestsEffects } from 'src/app/modules/ngrx-store/service-requests/service-requests.effects';
import { TermsAndConditionsEffects } from 'src/app/modules/ngrx-store/terms-and-conditions/terms-and-conditions.effects';
import { YourHomeEffects } from 'src/app/modules/ngrx-store/your-home/your-home.effects';

import { sessionStateReducerFactory } from 'src/app/modules/ngrx-store/session-storage';
import { stateResetReducerFactory } from 'src/app/modules/ngrx-store/state-reset';

import * as fromRoot from 'src/app/modules/ngrx-store/reducers';

/**
 * Provides NgRx store configuration for the application
 * Replaces the NgrxStoreModule
 */
export function provideAppStore() {
	return [
		// Configure store
		provideStore({}),
		provideState(fromRoot.APP_DOMAIN_FEATURE_KEY, fromRoot.reducer),

		// Configure effects
		provideEffects([
			HomeResetEffects,
			ConstructionProgressEffects,
			YourHomeEffects,
			ServiceRequestsEffects,
			MessageEffects,
			RealtorEffects,
			TermsAndConditionsEffects
		]),

		// Configure devtools
		provideStoreDevtools({
			name: 'CP DevTools',
			logOnly: false
		}),

		// Meta reducers
		{
			provide: META_REDUCERS,
			deps: [StorageService],
			useFactory: sessionStateReducerFactory,
			multi: true
		},
		{
			provide: META_REDUCERS,
			useFactory: stateResetReducerFactory,
			multi: true
		}
	];
}
